import React from 'react';
import './partners.css';
import DomoticNavbar from '../Components/Navbar';

const Partners = () => {
  const partners = [
    {
      name: "Cisco",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Cisco_logo_blue_2016.svg/1200px-Cisco_logo_blue_2016.svg.png",
      image: "https://images.unsplash.com/photo-1597852074816-d933c7d2b988",
      description: "Líder mundial en redes y comunicaciones, Cisco impulsa la innovación en conectividad segura.",
      since: "2015",
      achievements: [
        "Partner Gold Certified",
        "Premio a la Excelencia en Implementaciones 2022",
        "Top Revenue Generator 2023"
      ]
    },
    {
      name: "Fortinet",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Fortinet_logo.svg/1200px-Fortinet_logo.svg.png",
      image: "https://images.unsplash.com/photo-1563986768609-322da13575f3",
      description: "Proveedor global de soluciones de ciberseguridad de alto rendimiento para las empresas más exigentes.",
      since: "2017",
      achievements: [
        "Premio al Partner del Año 2021",
        "Expertise en FortiGate y FortiSIEM",
        "Máximo nivel de certificaciones"
      ]
    },
    {
      name: "Hikvision",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/Hikvision_logo.svg/1200px-Hikvision_logo.svg.png",
      image: "https://images.unsplash.com/photo-1563986768609-322da13575f3",
      description: "Innovador líder en productos y soluciones de videovigilancia y seguridad inteligente.",
      since: "2016",
      achievements: [
        "Diamond Partner desde 2019",
        "Centro de Demostración Certificado",
        "Premio a la Innovación 2022"
      ]
    },
    {
      name: "Ubiquiti",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Ubiquiti_Networks_logo.svg/1200px-Ubiquiti_Networks_logo.svg.png",
      image: "https://images.unsplash.com/photo-1563986768609-322da13575f3",
      description: "Revolucionando las redes inalámbricas con tecnología de alto rendimiento y diseño innovador.",
      since: "2018",
      achievements: [
        "Elite Partner desde 2020",
        "Premio al Crecimiento más Rápido",
        "Especialistas en UniFi y EdgeMAX"
      ]
    }
  ];

  return (
    <div className="partners">
        <DomoticNavbar/>
      <header className="partners__header">
        <div className="partners__header-content">
          <h1 className="partners__title">NUESTROS <span>PARTNERS</span> ESTRATÉGICOS</h1>
          <p className="partners__subtitle">Colaboramos con los líderes de la industria para ofrecer soluciones de clase mundial</p>
        </div>
      </header>

      <section className="partners__intro">
        <div className="partners__container">
          <h2 className="partners__section-title">ALIANZAS QUE INSPIRAN</h2>
          <p className="partners__intro-text">
            Estas relaciones privilegiadas nos permiten acceder a tecnología de punta, 
            certificaciones exclusivas y soporte técnico de primer nivel para cada proyecto.
          </p>
        </div>
      </section>

      <section className="partners__grid">
        <div className="partners__container">
          {partners.map((partner, index) => (
            <article className="partner-card" key={index}>
              <div className="partner-card__badge">PARTNER OFICIAL DESDE {partner.since}</div>
              
              <div className="partner-card__content">
                <div className="partner-card__image-container">
                  <img 
                    src={partner.image} 
                    alt={partner.name} 
                    className="partner-card__image"
                    loading="lazy"
                  />
                </div>
                
                <div className="partner-card__info">
                  <div className="partner-card__logo-container">
                    <img 
                      src={partner.logo} 
                      alt={partner.name} 
                      className="partner-card__logo"
                      loading="lazy"
                    />
                  </div>
                  
                  <h3 className="partner-card__name">{partner.name}</h3>
                  <p className="partner-card__description">{partner.description}</p>
                  
                  <ul className="partner-card__achievements">
                    {partner.achievements.map((achievement, i) => (
                      <li key={i} className="partner-card__achievement">
                        <span className="partner-card__achievement-icon">✓</span>
                        {achievement}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="partners__benefits">
        <div className="partners__container">
          <h2 className="partners__section-title">VENTAJAS EXCLUSIVAS</h2>
          
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-card__icon">🏆</div>
              <h3 className="benefit-card__title">Certificaciones Premium</h3>
              <p className="benefit-card__text">Nuestro equipo cuenta con las más altas certificaciones técnicas de cada fabricante.</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-card__icon">🚀</div>
              <h3 className="benefit-card__title">Innovación Prioritaria</h3>
              <p className="benefit-card__text">Acceso anticipado a nuevas tecnologías antes de su lanzamiento oficial.</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-card__icon">🛡️</div>
              <h3 className="benefit-card__title">Soporte Directo</h3>
              <p className="benefit-card__text">Conexión directa con los equipos técnicos y de desarrollo de los fabricantes.</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-card__icon">💰</div>
              <h3 className="benefit-card__title">Beneficios Comerciales</h3>
              <p className="benefit-card__text">Condiciones especiales y programas de incentivos exclusivos.</p>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Partners;